module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    class: {
      'not_work': _vm.isHoliday(_vm.schedule)
    }
  }, [(!_vm.isHoliday(_vm.schedule)) ? _c('div', {
    staticClass: "record not_work",
    style: (_vm.workingDayStartLimit(_vm.schedule))
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventFiltered), function(visit) {
    return (!_vm.isHoliday(_vm.schedule)) ? _c('div', {
      staticClass: "record",
      style: (_vm.eventPosition(visit))
    }, [_vm._v("\n\t\t \n\t")]) : _vm._e()
  }), _vm._v(" "), (!_vm.isHoliday(_vm.schedule)) ? _c('div', {
    staticClass: "record not_work",
    style: (_vm.workingDayEndLimit(_vm.schedule))
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61a3d054"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/GeneralSchedue/components/HorizontalEvent.vue
// module id = 621
// module chunks = 0